let inject = [

  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class CategoriesMenuController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;

    this.status ={
      open:false
    };
  }

  $onInit(){
  }
}

CategoriesMenuController.$inject = inject;

export default CategoriesMenuController;





/** WEBPACK FOOTER **
 ** ./www/components/home/categories-menu/categories-menu.controller.js
 **/